export function getStudentTestBlockName(block, index) {
  const name = typeof block?.nombre === "string" ? block.nombre.trim() : "";
  return name || `Bloque ${index + 1}`;
}

export function getStudentTestTopicName(topic, index) {
  const name = typeof topic?.nombre === "string" ? topic.nombre.trim() : "";
  return name || `Tema ${index + 1}`;
}

export function filterMatchingTestBlocks(testStructure, tabLabel, allowFallbackToAll = true) {
  const normalizedTab = typeof tabLabel === "string" ? tabLabel.trim() : "";
  if (!normalizedTab || !Array.isArray(testStructure)) {
    return [];
  }

  const matchingBlocks = testStructure.filter((block, index) => (
    getStudentTestBlockName(block, index) === normalizedTab
  ));

  if (matchingBlocks.length > 0) {
    return matchingBlocks;
  }

  return allowFallbackToAll ? testStructure : [];
}
